import { render, staticRenderFns } from "./PluginEditions.vue?vue&type=template&id=8eced858&"
import script from "./PluginEditions.vue?vue&type=script&lang=js&"
export * from "./PluginEditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports